
var container = document.querySelector('.wm-hero')
if(container){
    var vid = document.querySelector('.wm-hero video')

    // progress movie on scroll
    function renderLoop(){
        var offset = window.scrollY
        var progress = offset / (window.innerWidth < 750 ? window.innerHeight / 1.5 : (window.innerWidth / 2))
        if(progress > 1) progress = 1
        if(progress < 0) progress = 0
        if(vid.readyState > 1){
            var duration = vid.duration
            vid.currentTime = duration * progress
        }
        requestAnimationFrame(renderLoop)
    }

    // the bottom offset for the sticky second section needs
    // to be dynamically calculated as it depends on its apparent size
    var othersection = container.parentElement.nextElementSibling
    othersection.style.position = 'sticky'
    var normalsrc = vid.getAttribute('data-desktop')
    var mobilesrc = vid.getAttribute('data-mobile')

    var currentvid = null
    function setupVideo(){
        if(window.innerWidth < 750){
            if(currentvid != mobilesrc){
                vid.src = mobilesrc
                currentvid = mobilesrc
                vid.play()
                vid.pause()
            }
        }else{
            if(currentvid != normalsrc){
                vid.src = normalsrc
                currentvid = normalsrc
                vid.play()
                vid.pause()
            }
        }
    }
    function calculateOffset(){
        // calculate position we need to reach
        var targetpos = window.innerWidth / (window.innerWidth < 750 ? 0.65 : 3.2) + (window.innerWidth < 750 ? 78 : 103)
        var wheight = window.innerHeight
        var rect = othersection.getBoundingClientRect()
        var height = rect.height
        var targetoffset = wheight - height - targetpos
        othersection.style.bottom = targetoffset+'px'
    }

    setupVideo()
    window.addEventListener('resize',() => setupVideo())
    calculateOffset()
    window.addEventListener('resize',() => calculateOffset())

    renderLoop()
}